import 'jquery';

export default {
  init() {
    console.log('testing homes');
    const BASEURL = 'https://shurm.test/';


    const mainContentTitle = document.querySelector('.search_content_title');
    let mainContentText = document.querySelector('.main-content__content');
    const content = document.querySelector('.main-content__content');

    window.addEventListener('load', (event) => {
      const loadedContent = `${ BASEURL }/wp-json/wp/v2/area`;
      event.preventDefault();
      function loadMainContent() {
        $.ajax({
            url: loadedContent,
            dataType: 'json',
            success(res) {
              // $('.container-content').html(res);
              $.each(res, function(i, tx){
                // $('.container-content').html(res);
                  if(tx.parent == 0) {
                    mainContentTitle.innerText = tx.name;
                    mainContentText.innerHTML =  tx.description;
                  }
              })
            },
          })
      }
      loadMainContent()
    });

    // function loadMainContent() {
    //   window.addEventListener('loaded', function (e){
    //     console.log('this is another test')
    //   })
    //   // if($('.facetwp-facet-location ').has('.checked')) {
    //   //
    //   // }
    // }
    // loadMainContent()

  },
};
